import React from "react";
import { Blocker } from "../../api/scheduleApi.ts";
import BlockerForm from "./BlockerForm.tsx";
import BlockerList from "./BlockerList.tsx";
import { Trans } from "@lingui/react/macro";
import InfoBox from "../util/InfoBox.tsx";

interface EventSettingsProps {
  onAddBlocker: (event: Blocker) => void;
  onDeleteBlocker: (id: string) => void;
  existingBlocker: Blocker[];
  isLoading: boolean;
  deletingBlockerId: string | null;
}

const BlockerSettings: React.FC<EventSettingsProps> = ({
  onAddBlocker,
  onDeleteBlocker,
  existingBlocker,
  isLoading,
  deletingBlockerId,
}) => {
  return (
    <>
      <InfoBox variant={"info"} className={"mb-4"}>
        <Trans>
          You can use blockers to block users from booking you in specific time
          frames while on vacation or during your dentists appointments.
        </Trans>
      </InfoBox>
      <BlockerForm
        onAddBlocker={onAddBlocker}
        existingBlocker={existingBlocker}
        isLoading={isLoading}
      />
      <BlockerList
        blockers={existingBlocker}
        onDeleteEvent={onDeleteBlocker}
        deletingId={deletingBlockerId}
      />
    </>
  );
};

export default BlockerSettings;
